var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import styles from "./holdingsDashboard.module.scss";
import { useAppSelector } from "src/hooks/redux";
import Backfill from "src/components/backfill/backfill";
import { getpledgeDummyData } from "src/apis/mock/data/get-pledge-data";
import { getPledgeRequest } from "src/apis/dashboard";
import _ from "lodash";
import StepNumberInput from "src/components/inputs/step-number-input";
import { ERROR_MESSAGE_PLEDGE } from "src/utils/constant";
const { REACT_APP_ENV } = process.env;
const Pledge = (props) => {
    const [PledgeData, setPledgeData] = useState(props.pledgeData);
    const [DisplayPledgeData, setDisplayPledgeData] = useState(props.pledgeData);
    const [positionLoading, setPositionLoading] = useState(true);
    const [lablecheck, setLablecheck] = useState(false);
    const [sortType, setSortType] = useState("Symbol");
    const [sortOrderType, setSortOrderType] = useState("asc");
    const [pledgeMargin, setpledgeMargin] = useState(0);
    const showTicker = useAppSelector((state) => state.app.showMarquee);
    // const { addReportData, reportHeightData } = useContext(ReportHeightContext);
    const [selectAllcancel, setSelectAllcancel] = useState(false);
    const fetchPledge = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            //  setPositionLoading(true);
            const pledgeRequestData = REACT_APP_ENV == "development"
                ? { data: getpledgeDummyData() }
                : yield getPledgeRequest();
            if (pledgeRequestData.data.body.Data.length > 0) {
                const arr = pledgeRequestData.data.body.Data;
                arr.forEach((singleElement) => {
                    singleElement.checkbox = false;
                });
                setSelectAllcancel(false);
                setPledgeData(arr);
            }
        }
        catch (error) {
            //setHoldings([]);
            console.error(error);
        }
        finally {
            setPositionLoading(false);
        }
    });
    useEffect(() => {
        fetchPledge();
    }, []);
    const handleSelectAllChange = (event) => {
        const checked = event.target.checked;
        setSelectAllcancel(checked);
        let pledgeMargin = 0.0;
        if (checked) {
            DisplayPledgeData.forEach((singleElement) => {
                singleElement.checkbox = true;
                pledgeMargin = pledgeMargin + singleElement.PledgeValue;
            });
        }
        else {
            setSelectAllcancel(false);
            setpledgeMargin(0.0);
            DisplayPledgeData.forEach((singleElement) => {
                singleElement.checkbox = false;
            });
        }
        setDisplayPledgeData(DisplayPledgeData);
        calculateMargin(DisplayPledgeData);
    };
    const oncheckBoxChange = (e, element) => {
        const checked = e.target.checked;
        const arr = [...DisplayPledgeData];
        if (checked) {
            let tempArrAllChecked = 0;
            arr.forEach((item) => {
                if (item.ISINCode == element.ISINCode) {
                    item.checkbox = true;
                    tempArrAllChecked += 1;
                }
                if (item.checkbox) {
                    tempArrAllChecked += 1;
                }
            });
            if (arr.length + 1 == tempArrAllChecked) {
                setSelectAllcancel(true);
            }
        }
        else {
            arr.forEach((item) => {
                if (item.ISINCode == element.ISINCode) {
                    item.checkbox = false;
                    if (item.checkbox === false) {
                        setSelectAllcancel(false);
                    }
                }
            });
        }
        setDisplayPledgeData(arr);
        calculateMargin(arr);
    };
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    const onSortTypeChange = (newValue) => {
        if (newValue != sortType) {
            setSortType(newValue);
            setSortOrderType("asc");
        }
        else {
            incrementSortOrderType();
        }
    };
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    const incrementSortOrderType = () => {
        let newSortOrderType = false;
        if (!sortOrderType) {
            newSortOrderType = "asc";
        }
        else if (sortOrderType == "asc") {
            newSortOrderType = "desc";
        }
        else if (sortOrderType == "desc") {
            newSortOrderType = false;
            setSortType("");
        }
        setSortOrderType(newSortOrderType);
        // return newSortOrderType;
    };
    //@typescript-eslint/explicit-function-return-type
    const getArrowStyle = (localSortType) => {
        let returnStyle = styles.sortArrow;
        if (sortType == localSortType) {
            if (sortOrderType == "asc")
                returnStyle = styles.sortAsc;
            else if (sortOrderType == "desc")
                returnStyle = styles.sortDesc;
        }
        return returnStyle;
    };
    const sortDataCallback = () => {
        let newSortedList = DisplayPledgeData;
        // The time taken in the switch statement is independent of the number of case. It then basically becomes O(1) time complexity
        switch (sortType) {
            case "Symbol":
                newSortedList = _.orderBy(DisplayPledgeData, ["ScripName"], [sortOrderType]);
                break;
            case "Marginpledge":
                newSortedList = _.orderBy(DisplayPledgeData, ["PledgeValue"], [sortOrderType]);
                break;
            case "MTFPledge":
                newSortedList = _.orderBy(DisplayPledgeData, ["MTFPledge"], [sortOrderType]);
                break;
            case "DPQty":
                newSortedList = _.orderBy(DisplayPledgeData, ["DPQty"], [sortOrderType]);
                break;
            case "Category":
                newSortedList = _.orderBy(DisplayPledgeData, ["Category"], [sortOrderType]);
                break;
            case "customQty":
                newSortedList = _.orderBy(DisplayPledgeData, ["customQty"], [sortOrderType]);
        }
        setDisplayPledgeData(newSortedList);
    };
    useEffect(() => {
        sortDataCallback();
    }, [sortType, sortOrderType]);
    const calculateMargin = (data) => {
        let marginAddition = 0.0;
        const arr = data;
        const orignalArray = PledgeData;
        let totalmargin = 0.0;
        let calculateOnemargin = 0.0;
        arr.forEach((item, index) => {
            orignalArray.forEach((element, indexOforiginal) => {
                if (element.ISINCode === item.ISINCode) {
                    calculateOnemargin =
                        PledgeData[indexOforiginal].PledgeValue /
                            PledgeData[indexOforiginal].DPQty;
                }
            });
            if (item.checkbox === true) {
                if (item.customQty > 0 && item.customQty <= item.DPQty) {
                    marginAddition = calculateOnemargin * item.customQty;
                    arr[index].PledgeValue = marginAddition;
                    totalmargin += arr[index].PledgeValue;
                }
                else if (item.customQty === 0 || item.customQty > item.DPQty) {
                    arr[index].PledgeValue = 0.0;
                }
            }
        });
        setpledgeMargin(totalmargin);
        setDisplayPledgeData(arr);
        props.setSubmit(arr);
        props.finalCheck(lablecheck);
    };
    return (_jsx("div", Object.assign({ className: styles.modalWrapper }, { children: _jsx("div", Object.assign({ className: styles.modalBodyPart }, { children: PledgeData.length === 0 ? (_jsx("div", Object.assign({ className: `${styles.backfillLoaderContainer}` }, { children: _jsx(Backfill, { errorMessage: " Sorry! No record found." }) }))) : (_jsxs("div", Object.assign({ className: "pledge-data" }, { children: [_jsxs("table", Object.assign({ className: `w-100 pledge-table` }, { children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: _jsx("input", { type: "checkbox", checked: selectAllcancel, onChange: (event) => {
                                                    {
                                                        handleSelectAllChange(event);
                                                    }
                                                } }) }), _jsxs("th", { children: ["Scrip", _jsx("span", { className: getArrowStyle("Symbol"), onClick: () => {
                                                        onSortTypeChange("Symbol");
                                                    } })] }), _jsxs("th", Object.assign({ className: "text-center" }, { children: ["Stock Category", _jsx("span", { className: getArrowStyle("Category"), onClick: () => {
                                                        onSortTypeChange("Category");
                                                    } })] })), _jsxs("th", Object.assign({ className: "text-center" }, { children: ["DP Free", _jsx("span", { className: getArrowStyle("DPQty"), onClick: () => {
                                                        onSortTypeChange("DPQty");
                                                    } })] })), _jsxs("th", Object.assign({ className: "text-center" }, { children: ["Qty. to be Pledged", _jsx("span", { className: getArrowStyle("customQty"), onClick: () => {
                                                        onSortTypeChange("customQty");
                                                    } })] })), _jsxs("th", Object.assign({ className: "text-right" }, { children: ["Margin benefit", _jsx("span", { className: getArrowStyle("Marginpledge"), onClick: () => {
                                                        onSortTypeChange("Marginpledge");
                                                    } })] }))] }) }), _jsx("tbody", { children: DisplayPledgeData.map((item, index) => (_jsxs("tr", { children: [_jsx("td", { children: _jsx("input", { type: "checkbox", checked: item.checkbox, onChange: (event) => {
                                                    oncheckBoxChange(event, item);
                                                } }) }), _jsx("td", { children: item.ScripName }), _jsx("td", Object.assign({ className: "text-center" }, { children: item.Category })), _jsx("td", Object.assign({ className: "text-center" }, { children: item.DPQty })), _jsx("td", Object.assign({ className: "text-center" }, { children: _jsx("div", Object.assign({ className: "holdingsStepinputControl" }, { children: _jsx(StepNumberInput, { inputLabel: "", defaultValue: item.customQty, stepInput: 1, errorMessage: "Invalid Qty", showError: item.checkbox &&
                                                        (item.customQty === 0 ||
                                                            item.customQty > item.DPQty)
                                                        ? true
                                                        : false, errorInfo: item.checkbox &&
                                                        (item.customQty === 0 ||
                                                            item.customQty > item.DPQty)
                                                        ? true
                                                        : false, allowZero: true, toolTipErrorMessage: ERROR_MESSAGE_PLEDGE, returnValue: (a) => {
                                                        if (!isNaN(a)) {
                                                            const custInput = a;
                                                            const displaydata = [...DisplayPledgeData];
                                                            displaydata[index].customQty = custInput;
                                                            setDisplayPledgeData(displaydata);
                                                            calculateMargin(displaydata);
                                                        }
                                                        else {
                                                            setDisplayPledgeData(PledgeData);
                                                        }
                                                    }, disabled: !item.checkbox }) })) })), _jsx("td", Object.assign({ className: "text-right" }, { children: item.PledgeValue.toFixed(2) }))] }, index))) }), _jsx("tfoot", { children: _jsx("tr", { children: _jsxs("td", Object.assign({ className: "text-right footertxt", colSpan: 4 }, { children: ["Total Margin Benefit:", _jsx("span", Object.assign({ className: "mediumWeight ms-1" }, { children: pledgeMargin.toFixed(2) }))] })) }) })] })), _jsx("div", Object.assign({ className: "bottom-text" }, { children: _jsxs("label", Object.assign({ htmlFor: "confirmcheck", onClick: (e) => {
                                setLablecheck(!lablecheck);
                                props.finalCheck(!lablecheck);
                            } }, { children: [_jsx("input", { id: "confirmcheck", type: "checkbox", checked: lablecheck }), "I here by confirm that I am aware that the securities pledge by me in favour of 5paisa Capital Limited towards margins may br re-pledged by them in favour of the clearing corporation, as the case may be and that I hereby accord my unconditional consent for the same."] })) }))] }))) })) })));
};
export default Pledge;
